<template>
  <div id="avaliacao-treinamento">
    <div class="container main">
      <v-alert v-if="error" type="error" dismissible @input="error = false">
        {{ errorMessage }}
      </v-alert>

      <div v-if="!enviadoComSucesso">
        <v-card
          v-if="etapa === 1"
          class="mx-auto card-responsive card-spacing card-top"
        >
          <ValidationObserver ref="observer" v-slot="{ validate }">
            <div>
              <v-img
                :src="require('@/assets/images/avaliacao_banner.png')"
                class="fill-width centered-image"
              ></v-img>
              <v-card-title id="tituloavaliacao" class="title-large">
                AVALIAÇÃO DO NOSSO TREINAMENTO
              </v-card-title>
              <v-card-subtitle class="text-center description-spacing">
                <p><strong>Olá!👋 Seja bem vindo ou bem vinda. 😍</strong></p>
                <p>
                  Por gentileza, nos forneça um feedback com sua avaliação sobre
                  este treinamento.
                </p>
                <p>
                  Desde já, agradecemos a você pela motivação e interesse por
                  este conteúdo tão importante para o desenvolvimento da saúde
                  digital na APS.
                </p>
              </v-card-subtitle>
              <v-card-text>
                <div class="form-row">
                  <div class="form-group">
                    <label for="estado">ESTADO</label>
                    <ValidationProvider
                      name="Estado"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <vue-select
                        :options="estados"
                        label="uf"
                        placeholder="Selecione um estado"
                        v-model="form.estado"
                        @input="buscarCidades"
                        class="vue-select"
                      ></vue-select>
                      <span v-if="errors.length" class="text-danger">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group ml-3">
                    <label for="cidade">CIDADE</label>
                    <ValidationProvider
                      name="Cidade"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <vue-select
                        :options="cidades"
                        label="no_municipio"
                        placeholder="Selecione uma cidade"
                        v-model="form.cidade"
                        @input="verificarCidade"
                        :disabled="cidades.length === 0"
                        class="vue-select"
                        :loading="loading"
                      ></vue-select>
                      <span v-if="errors.length" class="text-danger">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-row mt-3">
                  <ValidationProvider
                    name="Termos de uso"
                    rules="requiredCheckbox"
                    v-slot="{ errors }"
                  >
                    <div class="checkbox-termos">
                      <div id="checkboxdostermos">
                        <input
                          type="checkbox"
                          id="termos"
                          v-model="form.termos"
                        />
                        <label for="termos" class="termos-label">
                          Li e estou de acordo com os
                          <span @click="abrirModalTermos" class="link-termos"
                            >Termos de uso.</span
                          >
                        </label>
                      </div>
                      <span v-if="errors.length" class="text-danger">{{
                        errors[0]
                      }}</span>
                    </div>
                  </ValidationProvider>
                </div>
                <div class="form-actions mt-3">
                  <button
                    type="button"
                    @click="proximaEtapa(2, validate)"
                    class="btn btn-primary btn-proximo"
                  >
                    Próximo
                  </button>
                </div>
              </v-card-text>
            </div>
          </ValidationObserver>
        </v-card>

        <v-card
          v-if="etapa === 2"
          class="mx-auto card-responsive card-spacing card-center"
        >
          <ValidationObserver ref="observer" v-slot="{ validate }">
            <v-card-text>
              <div class="form-row mt-3">
                <div class="form-group">
                  <label for="funcao">FUNÇÃO</label>
                  <ValidationProvider
                    name="Função"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <vue-select
                      :options="funcoes"
                      placeholder="Selecione sua ocupação"
                      v-model="form.funcao"
                      @input="verificarFuncao"
                      class="vue-select"
                    ></vue-select>
                    <span v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div v-if="mostrarUBS" class="form-row mt-3">
                <div class="form-group">
                  <label for="ubs">LOCAL DE TRABALHO</label>
                  <ValidationProvider
                    name="UBS"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <vue-select
                      :options="ubs"
                      placeholder="Selecione um local"
                      v-model="form.ubs"
                      label="no_ubs"
                      @input="verificarUBS"
                      class="vue-select"
                    ></vue-select>
                    <span v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="form-group mt-3">
                <label for="instagram">INSTAGRAM</label>
                <p>
                  Por favor, informe seu Instagram para que possamos mencioná-lo
                  na postagem em nossa página
                  <a href="https://www.instagram.com/biatic/" target="_blank"
                    >@biatic</a
                  >
                  sobre este treinamento.
                </p>
                <ValidationProvider name="Instagram" v-slot="{ errors }">
                  <input
                    id="instagram"
                    class="form-control"
                    v-model="form.instagram"
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="form-actions mt-3">
                <button
                  type="button"
                  @click="anteriorEtapa"
                  class="btn btn-secondary"
                >
                  Anterior
                </button>
                <button
                  type="button"
                  @click="proximaEtapa(3, validate)"
                  class="btn btn-primary btn-proximo"
                >
                  Próximo
                </button>
              </div>
            </v-card-text>
          </ValidationObserver>
        </v-card>

        <v-card
          v-if="etapa === 3"
          class="mx-auto card-responsive card-spacing card-center"
        >
          <ValidationObserver ref="observer" v-slot="{ validate }">
            <v-card-text>
              <div class="form-group mt-3">
                <label>Você conhece o Programa SUS DIGITAL?</label>
                <ValidationProvider
                  name="Programa SUS DIGITAL"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="btn-group">
                    <v-btn
                      :class="{
                        'btn-active': form.conhece_sus_digital === 'sim',
                      }"
                      @click="setConheceSUSDigital('sim')"
                      depressed
                    >
                      Sim
                    </v-btn>
                    <v-btn
                      :class="{
                        'btn-active': form.conhece_sus_digital === 'nao',
                      }"
                      @click="setConheceSUSDigital('nao')"
                      depressed
                    >
                      Não
                    </v-btn>
                    <input type="hidden" v-model="form.conhece_sus_digital" />
                  </div>
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div
                class="form-group mt-3"
                v-if="form.conhece_sus_digital === 'sim'"
              >
                <label for="descricao_compreensao_usuario"
                  >Poderia descrever brevemente sua compreensão do
                  programa?</label
                >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <textarea
                    id="descricao_compreensao_usuario"
                    rows="4"
                    class="form-control"
                    v-model="form.descricao_compreensao_usuario"
                  ></textarea>
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <SpeechRecognition
                  :targetModel.sync="form.descricao_compreensao_usuario"
                />
              </div>
              <div
                class="form-group mt-3"
                v-if="form.conhece_sus_digital === 'sim'"
              >
                <label for="uso_sus_digital_trabalho"
                  >De que maneira você gostaria de utilizar o SUS DIGITAL em seu
                  trabalho diário para facilitar seu dia a dia e melhorar o
                  atendimento ao cidadão?</label
                >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <textarea
                    id="uso_sus_digital_trabalho"
                    rows="4"
                    class="form-control"
                    v-model="form.uso_sus_digital_trabalho"
                  ></textarea>
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <SpeechRecognition
                  :targetModel.sync="form.uso_sus_digital_trabalho"
                />
              </div>
              <div class="form-actions mt-3">
                <button
                  type="button"
                  @click="anteriorEtapa"
                  class="btn btn-secondary"
                >
                  Anterior
                </button>
                <button
                  type="button"
                  @click="proximaEtapa(4, validate)"
                  class="btn btn-primary btn-proximo"
                >
                  Próximo
                </button>
              </div>
            </v-card-text>
          </ValidationObserver>
        </v-card>

        <v-card
          v-if="etapa === 4"
          class="mx-auto card-responsive card-spacing card-center"
        >
          <ValidationObserver ref="observer" v-slot="{ validate }">
            <v-card-text>
              <div class="form-group mt-3">
                <label for="opiniaoTreinamento"
                  >Qual é a sua opinião sobre este treinamento? Por favor,
                  comente sobre os aspectos positivos e negativos, e sugira
                  possíveis melhorias.</label
                >
                <ValidationProvider
                  name="Opinião Treinamento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <textarea
                    id="opiniaoTreinamento"
                    rows="4"
                    class="form-control"
                    v-model="form.opiniaoTreinamento"
                    required
                  ></textarea>
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <SpeechRecognition
                  :targetModel.sync="form.opiniaoTreinamento"
                />
              </div>
              <div class="form-group mt-3">
                <label for="dataTreinamento">Data do treinamento</label>
                <ValidationProvider
                  name="Data Treinamento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="date"
                    id="dataTreinamento"
                    class="form-control date-input"
                    v-model="form.dt_treinamento"
                    required
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <p v-if="!form.dt_treinamento" class="text-danger">
                  Selecione uma data para prosseguir
                </p>
              </div>
              <div class="form-group mt-3">
                <label for="sugestao_tema"
                  >Informe o tema de treinamento que você gostaria de receber
                  para aprimorar suas habilidades na área da saúde
                  digital.</label
                >
                <ValidationProvider
                  name="Tema Treinamento"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <textarea
                    id="sugestao_tema"
                    rows="4"
                    class="form-control"
                    v-model="form.sugestao_tema"
                    required
                  ></textarea>
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <SpeechRecognition :targetModel.sync="form.sugestao_tema" />
              </div>
              <div class="form-actions mt-3">
                <button
                  type="button"
                  @click="anteriorEtapa"
                  class="btn btn-secondary"
                >
                  Anterior
                </button>
                <button
                  type="button"
                  @click="proximaEtapa(5, validate)"
                  class="btn btn-primary btn-proximo"
                >
                  Próximo
                </button>
              </div>
            </v-card-text>
          </ValidationObserver>
        </v-card>

        <ValidationObserver ref="observerNps" v-slot="{ validate }">
          <Nps
            v-if="etapa === 5"
            @anterior-etapa="anteriorEtapa"
            @proxima-etapa="() => enviarFormulario(validate)"
            @update:nps="form.nps = $event"
            @update:escala="form.escala = $event"
          />
        </ValidationObserver>
      </div>

      <v-card
        v-if="enviadoComSucesso"
        class="mx-auto card-responsive card-spacing card-top"
      >
        <v-img
          :src="require('@/assets/images/avaliacao_banner.png')"
          class="fill-width centered-image"
        ></v-img>
        <v-card-title id="tituloavaliacao" class="title-large">
          Obrigado por sua participação!
        </v-card-title>
        <v-card-subtitle class="text-center description-spacing">
          <p>Agradecemos seu feedback sobre o treinamento.</p>
          <p>
            Sua opinião é essencial para nós e nos ajuda a aprimorar
            continuamente nossos programas.
          </p>
          <p>AbraSUS! 👏</p>
        </v-card-subtitle>
        <v-card-actions class="justify-center mt-3">
          <v-btn id="btn-voltar" @click="redirecionarInicio">INÍCIO</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <footer class="footer">Todos os direitos reservados © 2024</footer>

    <ModalTermos
      v-if="showModalTermos"
      @close-modal-termos="closeModalTermos"
      @aceitar-termos="aceitarTermos"
    >
    </ModalTermos>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { apiPublic } from '@/plugins/axios.js'
import ModalTermos from '@/components/ModalTermos'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import SpeechRecognition from './components/SpeechRecognition.vue'
import Nps from './Nps.vue'

extend('requiredCheckbox', {
  validate: (value) => {
    return value === true
  },
  message: 'Você deve aceitar os Termos de uso',
})

extend('required', {
  ...required,
  message: 'Campo obrigatório',
})

export default {
  name: 'AvaliacaoTreinamento',
  components: {
    ValidationObserver,
    ValidationProvider,
    ModalTermos,
    'vue-select': VueSelect,
    SpeechRecognition,
    Nps,
  },
  data() {
    return {
      form: {
        estado: '',
        cidade: '',
        cidadeSelecionada: null,
        funcao: '',
        ubs: '',
        instagram: '',
        conhece_sus_digital: '',
        descricao_compreensao_usuario: '',
        uso_sus_digital_trabalho: '',
        opiniaoTreinamento: '',
        sugestao_tema: '',
        dt_treinamento: '',
        nps: null,
        escala: '',
        termos: false,
      },
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SE' },
        { uf: 'TO' },
      ],
      cidades: [],
      funcoes: [
        { label: 'Gerente/Coordenador(a)', value: 'Gerente/Coordenador(a)' },
        { label: 'Secretário(a)', value: 'Secretário(a)' },
        {
          label: 'Agente Comunitário de Saúde (ACS)',
          value: 'Agente Comunitário de Saúde (ACS)',
        },
        { label: 'Aux/Téc Enfermagem', value: 'Aux/Téc Enfermagem' },
        { label: 'Enfermeiro(a)', value: 'Enfermeiro(a)' },
        { label: 'Médico(a)', value: 'Médico(a)' },
        { label: 'Odontólogo(a)', value: 'Odontólogo(a)' },
        { label: 'Recepcionista', value: 'Recepcionista' },
        {
          label: 'Agente Comunitário de Endemias (ACE)',
          value: 'Agente Comunitário de Endemias (ACE)',
        },
        {
          label: 'Coordenador(a) de Vigilância em Saúde',
          value: 'Coordenador(a) de Vigilância em Saúde',
        },
        {
          label: 'Coordenador(a) de Imunização',
          value: 'Coordenador(a) de Imunização',
        },
        { label: 'Vacinador(a)', value: 'Vacinador(a)' },
        { label: 'Téc. Aux de Saúde Bucal', value: 'Téc. Aux de Saúde Bucal' },
        { label: 'Profissional da eMulti', value: 'Profissional da eMulti' },
        {
          label: 'Assessoria / consultoria',
          value: 'Assessoria / consultoria',
        },
        {
          label: 'Diretor(a) da atenção básica',
          value: 'Diretor(a) da atenção básica',
        },
        {
          label: 'Superintendência da atenção basica',
          value: 'Superintendência da atenção basica',
        },
        { label: 'Operador(a) de sistemas', value: 'Operador(a) de sistemas' },
        {
          label: 'Chefe de Divisão dos Sistemas de Informação',
          value: 'Chefe de Divisão dos Sistemas de Informação',
        },
        { label: 'Psicólogo(a)', value: 'Psicólogo(a)' },
        { label: 'Técnico do CPD', value: 'Técnico do CPD' },
        { label: 'Administrativo', value: 'Administrativo' },
        { label: 'T.I.', value: 'T.I.' },
        { label: 'Apoio Técnico', value: 'Apoio Técnico' },
        { label: 'Outro', value: 'Outro' },
      ],
      ubs: [],
      funcoesEspecificas: [
        'Agente Comunitário de Saúde (ACS)',
        'Aux/Téc Enfermagem',
        'Enfermeiro(a)',
        'Médico(a)',
        'Odontólogo(a)',
        'Recepcionista',
        'Téc. Aux de Saúde Bucal',
      ],
      etapa: 1,
      showModalTermos: false,
      loading: false,
      error: false,
      errorMessage: '',
      enviadoComSucesso: false,
    }
  },
  computed: {
    mostrarUBS() {
      return this.funcoesEspecificas.includes(this.form.funcao)
    },
    todosCamposPreenchidos() {
      return (
        this.form.estado &&
        this.form.cidade &&
        this.form.funcao &&
        this.form.conhece_sus_digital &&
        this.form.opiniaoTreinamento &&
        this.form.dt_treinamento &&
        (!this.mostrarUBS || this.form.ubs)
      )
    },
  },
  methods: {
    async buscarCidades(event) {
      if (!event || !event.uf) {
        this.cidades = []
        this.form.cidade = ''
        this.form.cidadeSelecionada = null
        return
      }

      this.loading = true
      this.error = false
      this.form.cidade = ''
      this.form.cidadeSelecionada = null
      try {
        const response = await apiPublic.get(`/estados/${event.uf}/cidades`)
        this.cidades = response.data
      } catch (error) {
        console.error('Erro ao buscar cidades:', error)
        this.cidades = []
        this.error = true
        this.errorMessage =
          'Erro ao buscar cidades. Por favor, tente novamente mais tarde.'
      } finally {
        this.loading = false
      }
    },
    verificarCidade(cidade) {
      const cidadeSelecionada = this.cidades.find(
        (c) => c.no_municipio === cidade.no_municipio
      )
      if (cidadeSelecionada) {
        this.form.cidadeSelecionada = cidadeSelecionada
      } else {
        this.form.cidadeSelecionada = null
      }
    },
    async verificarFuncao(event) {
      this.form.funcao = event.value
      if (this.mostrarUBS) {
        const cidadeSelecionada = this.form.cidadeSelecionada
        if (cidadeSelecionada) {
          try {
            const response = await apiPublic.get(
              `/cofinanciamento-federal-aps/ubs/${cidadeSelecionada.co_ibge}`
            )
            this.ubs = response.data
            this.ubs.push({ no_ubs: 'Outro' })
          } catch (error) {
            console.error('Erro ao buscar UBSs:', error)
            this.ubs = []
            this.error = true
            this.errorMessage =
              'Erro ao buscar UBSs. Por favor, tente novamente mais tarde.'
          }
        } else {
          console.error('Nenhuma cidade selecionada para buscar UBSs.')
        }
      } else {
        this.ubs = []
      }
    },
    verificarUBS() {
      const ubsSelecionada = this.ubs.find(
        (ubs) => ubs.no_ubs === this.form.ubs
      )
    },
    setConheceSUSDigital(value) {
      this.form.conhece_sus_digital = value
      this.$nextTick(() => {
        this.$refs.observer.validate()
      })
    },
    async proximaEtapa(etapa, validate) {
      const isValid = await validate()
      if (isValid) {
        this.etapa = etapa
      } else {
      }
    },
    anteriorEtapa() {
      if (this.etapa > 1) {
        this.etapa -= 1
      }
    },
    voltarAoInicio() {
      this.etapa = 1
      this.resetFormulario()
    },
    redirecionarInicio() {
      window.location.href = 'https://esusfeedback.com.br/avaliacao-treinamento'
    },
    resetFormulario() {
      this.form = {
        estado: '',
        cidade: '',
        cidadeSelecionada: null,
        funcao: '',
        ubs: '',
        instagram: '',
        conhece_sus_digital: '',
        descricao_compreensao_usuario: '',
        uso_sus_digital_trabalho: '',
        opiniaoTreinamento: '',
        sugestao_tema: '',
        dt_treinamento: '',
        nps: null,
        escala: '',
        termos: false,
      }
    },
    async enviarFormulario(validate) {
      const isValid = await validate()
      if (isValid) {
        const formData = {
          ibge: this.form.cidadeSelecionada
            ? this.form.cidadeSelecionada.co_ibge
            : '',
          municipio: `${this.form.cidade.no_municipio} - ${this.form.estado.uf}`,
          cnes: this.form.ubs.cnes ? this.form.ubs.cnes : null,
          ubs: this.form.ubs.no_ubs ? this.form.ubs.no_ubs : null,
          dados: {
            funcao: this.form.funcao,
            instagram: this.form.instagram,
            conhece_sus_digital: this.form.conhece_sus_digital,
            descricao_compreensao_usuario:
              this.form.descricao_compreensao_usuario,
            uso_sus_digital_trabalho: this.form.uso_sus_digital_trabalho,
            opiniaoTreinamento: this.form.opiniaoTreinamento,
            sugestao_tema: this.form.sugestao_tema,
            dt_treinamento: this.form.dt_treinamento,
            termos: this.form.termos,
            nps: this.form.nps,
            escala: this.form.escala,
          },
        }

        try {
          const response = await apiPublic.post(
            '/avaliacao-treinamento/avaliacao',
            formData
          )
          this.resetFormulario()
          this.enviadoComSucesso = true
        } catch (error) {
          console.error('Erro ao enviar o formulário:', error)
          this.$toast.error(
            'Erro ao enviar o formulário. Por favor, tente novamente mais tarde.',
            'Erro:',
            {
              position: 'topRight',
            }
          )
        }
      } else {
        // this.$toast.error('Por favor, preencha todos os campos obrigatórios.', 'Erro:', {
        //   position: 'topRight',
        // });
      }
    },
    abrirModalTermos() {
      this.showModalTermos = true
    },
    closeModalTermos() {
      this.showModalTermos = false
      this.form.termos = false
    },
    aceitarTermos() {
      this.showModalTermos = false
      this.form.termos = true
    },
  },
}
</script>

<style>
.main {
  margin: 35px auto;
  min-height: 90vh;
}

b,
strong {
  font-weight: bolder;
  font-size: 18px;
}

p {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
}

#avaliacao-treinamento {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 0%),
    0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12) !important;
  background-color: #f7f7f7;
}

.container {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.footer {
  background-color: #e9ecef;
  text-align: center;
  padding: 10px 0;
  width: 100%;
  bottom: 0;
}

form {
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.form-group {
  flex: 1;
  margin-right: 10px;
  text-align: left;
  padding-top: 20px;
}

.ml-3 {
  margin-left: 10px;
}

#tituloavaliacao {
  display: block;
}

label {
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 16px;
  padding-bottom: 12px;
}

select.form-control,
input.form-control,
textarea.form-control {
  width: 100%;
  padding: 5px;
  font-size: 16px;
  padding-right: 7%;
}

.text-danger {
  color: red;
  font-size: 12px;
}

.card-responsive {
  width: 75%;
}

/* @media(min-width: 768px) {
  .card-responsive {
    width: 75% !important;
  }
} */

.fill-width {
  width: 100%;
  height: auto !important;
  object-fit: cover;
}

.centered-image {
  display: block;
  margin: 0 auto 20px auto;
}

.card-spacing {
  margin-top: 10px;
  margin-bottom: 10px;
}

.title-large {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.description-spacing {
  margin-top: 20px;
}

.date-input {
  width: auto;
  max-width: 200px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px !important;
}

.btn {
  height: 40px;
  padding: 5px 20px;
  display: inline-block;
  font-size: 16px;
  border: none;
  cursor: pointer;
  border-radius: 20px;
  box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.25);
  width: 40%;
}

.btn-proximo {
  margin-left: auto;
}

.btn-primary {
  background-color: #0fafd7;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #3e4042;
  color: white;
}

.btn-primary:hover {
  color: #fff !important;
  background-color: #0069d9;
  border-color: #0062cc;
}

.btn-active {
  background-color: #0fafd7 !important;
  color: white !important;
}

.link-termos {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.checkbox-termos {
  display: block;
  align-items: center;
}

.checkbox-termos input {
  margin-right: 10px;
}

.checkbox-termos {
  display: block;
  align-items: center;
  margin-top: 50px;
}

.btn-group {
  display: flex;
  gap: 10px;
}

.card-top {
  margin-top: 0;
}

.card-center {
  display: block;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
  padding: 10px;
}

.card-center .v-card__text {
  margin-top: auto;
  margin-bottom: auto;
}

.theme--light.v-btn.v-btn--icon {
  color: rgba(0, 0, 0, 0.54);
  margin-top: -129px;
  margin-left: 93%;
}

@media (max-width: 767px) {
  .card-center {
    height: auto;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .card-responsive {
    width: 100% !important;
  }
  .form-row {
    display: block;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .ml-3 {
    margin-left: 0px !important;
  }
  .checkbox-termos {
    display: block;
    align-items: center;
    margin-top: 50px;
  }

  .theme--light.v-btn.v-btn--icon {
    color: rgba(0, 0, 0, 0.54);
    margin-top: -129px;
    margin-left: 275px;
  }

  select.form-control,
  input.form-control,
  textarea.form-control {
    width: 100%;
    padding: 5px;
    font-size: 16px;
    padding-right: 40px;
  }
}

.vue-select {
  width: 100%;
}

#comogostaria {
  padding-bottom: 20px;
}

.mt-3 {
  margin-top: 16px;
}

.justify-center {
  display: flex;
  justify-content: center;
}

#checkboxdostermos {
  display: block;
}

#btn-voltar {
  background-color: #0fafd7 !important;
  color: white !important;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 4px;
  text-transform: none;
}

#dataTreinamento {
  width: 100%;
  padding: 5px;
  font-size: 16px;
  padding-right: 10px;
}
</style>
